/**
 * Formula model (docs/contracts/formula.md). Percentages are in points (70 = 70 %), masses in
 * grams. Grams are never stored: they are derived from percentages and the anchor.
 */
/** In the order `overrides` lists them. */
export const OVERRIDABLE_FIELDS = [
    'kind',
    'water',
    'fat',
    'sugar',
    'yeast',
];
export const PREPARATION_STATES = [
    'cold',
    'roomTemperature',
    'softened',
    'melted',
    'meltedCooled',
    'cubed',
    'chopped',
    'grated',
    'ground',
    'toasted',
    'soaked',
    'whipped',
    'beaten',
    'pureed',
    'cooked',
    'other',
];
//# sourceMappingURL=types.js.map